export const Modal = {
  titleEditOrder: 'Editar Pedido nº',
  titleRestoreOrder: 'Restaurar Pedido(s) ',
  titleRejectOrder: 'Rejeitar Pedido ',
  labelVolumes: 'Nº de Volumes',
  labelPallet: 'Nº de Paletes',
  labelEquivalentPallet: 'Nº de Paletes Equivalentes',
  labelNormalEquivalentPallet: '= Equivale Nº Palete EURO',
  labelWeight: 'Peso Aproximado (kg)',
  labelVolume: 'Volume Aproximado (m3)',
  labelReason: 'Motivo',
  labelDisponibilityDate: 'Data de Disponibilidade',
  labelNewDisponibilityDate: 'Insira nova data de disponibilidade',
  labelComments: 'Comentários',
  placeholderDropDown: '-- Seleccione --',
  warningRestoreOrder: 'Tem a certeza de que quer restaurar o Pedido(s) {order}?',
  Yes: 'Sim',
  No: 'Não',
  titleNotRevert: 'Pedido que não pode ser revertido | Pedidos que não podem ser revertidos',
  warningDirtyCttOrders: 'Pedido CTT: {orders} | Pedidos CTT: {orders}',
  warningDirtyRevert: 'Outro Pedido: {orders} | Outros Pedidos: {orders}',
  reasonRejectOrder: 'Qual o motivo da rejeição do pedido {order}?'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Modal.js